export const selectCartSummaryPrices = (state) => {
  const orderView = state?.cartDetails?.cartDetailsJson?.orderDetailsView;
  const checkoutOrder = state?.checkout?.orderDetails;

  return {
    today: orderView?.dueTodayAmount ?? checkoutOrder?.totalDueToday ?? 0,
    monthly: orderView?.dueMonthlyAmount ?? checkoutOrder?.totalMonthlyDue ?? 0,
    savings: orderView?.dueMonthlyDiscountAmount ?? checkoutOrder?.dueMonthlyDiscountAmount ?? 0,
  };
};

export const hasCartSummaryData = ({ today = 0, monthly = 0, savings = 0 } = {}) =>
  Number(today) > 0 || Number(monthly) > 0 || Number(savings) > 0;

export const selectHasCartSummaryData = (state) => hasCartSummaryData(selectCartSummaryPrices(state));

export const hasValidPlanItem = (items = []) =>
  Array.isArray(items) &&
  items
    .filter((item) => (item?.itemType || item?.cartItemType)?.toUpperCase() === 'PLAN')
    .some((item) => (item?.itemName || item?.name || '').trim());

export const selectHasValidPlan = (state) => {
  const dueMonthlyList = state?.cartDetails?.cartDetailsJson?.dueMonthlyList;
  const items = Array.isArray(dueMonthlyList) ? dueMonthlyList : [];

  return hasValidPlanItem(items);
};